import { TSingleChatV2Response } from '../../types/chatList';
import { EFirstMessageStatus } from '../../types/firstMessageStatus';
import { ITypedReduxAction } from '../../types/redux/actionType';

export const Messages = {
  [EFirstMessageStatus.ChatsBlocked]: 'Чаты заблокированы',
  [EFirstMessageStatus.ChatsDisabled]: 'Чаты отключены',
  [EFirstMessageStatus.NeedConfirmPhone]: 'Необходимо подтвердить телефон',
  [EFirstMessageStatus.UserCanNotChatWithHimself]: 'Нет возможности создать чат с самим собой',
};

export enum EFirstMessageActionTypes {
  Pending = 'firstMessage/pending',
  Sent = 'firstMessage/sent',
  Failed = 'firstMessage/failed',
  ChatsBlocked = 'firstMessage/chatsBlocked',
  NeedCaptcha = 'firstMessage/needCaptcha',
  NeedConfirmPhone = 'firstMessage/needConfirmPhone',
  UserChatsDisabled = 'firstMessage/userChatsDisabled',
  ValidationError = 'firstMessage/validationError',
}

export interface IFirstMessageSentPayload {
  chat: TSingleChatV2Response;
}

type TFirstMessagePending = ITypedReduxAction<EFirstMessageActionTypes.Pending>;
type TFirstMessageSent = ITypedReduxAction<EFirstMessageActionTypes.Sent, IFirstMessageSentPayload>;
type TFirstMessageFailed = ITypedReduxAction<EFirstMessageActionTypes.Failed>;
type TFirstMessageChatsBlocked = ITypedReduxAction<EFirstMessageActionTypes.ChatsBlocked>;
type TFirstMessageNeedCaptcha = ITypedReduxAction<EFirstMessageActionTypes.NeedCaptcha>;
type TFirstMessageNeedConfirmPhone = ITypedReduxAction<EFirstMessageActionTypes.NeedConfirmPhone>;
type TFirstMessageUserChatsDisabled = ITypedReduxAction<EFirstMessageActionTypes.UserChatsDisabled>;
type TFirstMessageValidationError = ITypedReduxAction<EFirstMessageActionTypes.ValidationError>;

export type TFirstMessageActions =
  | TFirstMessagePending
  | TFirstMessageSent
  | TFirstMessageFailed
  | TFirstMessageChatsBlocked
  | TFirstMessageNeedCaptcha
  | TFirstMessageNeedConfirmPhone
  | TFirstMessageUserChatsDisabled
  | TFirstMessageValidationError;
